import { Typography } from '@mui/material'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'

interface Props {
  id: string
  error?: boolean
  label: string
}

const ValidationIndicator = ({ id, error, label }: Props): JSX.Element => {
  return (
    <Typography
      variant="overline"
      className={`form-validation-label-${id}`}
      color={error ? 'error' : 'secondary'}
      align="right"
      sx={{ whiteSpace: 'nowrap', marginTop: '5px', marginLeft: '2px' }}
    >
      {!error && (
        <CheckRoundedIcon
          sx={{ verticalAlign: '-4px', fontSize: '16px', marginRight: '2px' }}
        />
      )}
      {label}
    </Typography>
  )
}

export default ValidationIndicator
